import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { FELLOWS_CORNER_NEW_UNTIL } from '@/constants/fellowsCorner';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Whether to mark the Fellows Corner nav item as new.
 *
 * A date and nothing else. New describes the feature rather than the reader's
 * relationship to it, so someone who has already visited still sees a marker
 * that is still true, and the window closes for everyone at once.
 *
 * This replaced a per-user callout that cleared on the first visit. Clearing
 * needs to know where the reader is, and a redirect away from the page counted
 * as arriving at it, so the badge could be spent without anyone seeing what it
 * pointed at. Precision that a one-week marker on a single nav item did not
 * need, bought with a server round trip and a bug.
 */
export function useFellowsNavBadge(): boolean {
  const isFellowsCornerEnabled = useFeatureFlag(FEATURE_FLAGS.FELLOWS_CORNER);

  return isFellowsCornerEnabled && Date.now() < FELLOWS_CORNER_NEW_UNTIL.getTime();
}
